import DAR from '../../../../app/public/assets/Centros/501.webp';
import FUTURE from '../../../../app/public/assets/Centros/504.png';
import CLA from '../../../../app/public/assets/Centros/507.png';
import SCANCENTER from '../../../../app/public/assets/Centros/511.webp';
import HNORTE from '../../../../app/public/assets/Centros/512.webp';
import DIAGNOS from '../../../../app/public/assets/Centros/517.png';
import LONDRES from '../../../../app/public/assets/Centros/518.png';
import SSUCBBA from '../../../../app/public/assets/Centros/519.webp';
import CEMES from '../../../../app/public/assets/Centros/525.png';
import BELGA from '../../../../app/public/assets/Centros/526.png';
import ONCOSUR from '../../../../app/public/assets/Centros/528.webp';
import MEDCENT from '../../../../app/public/assets/Centros/532.png';
import RESOMEDICA from '../../../../app/public/assets/Centros/534.webp';
import SPACIO_MEDICO from '../../../../app/public/assets/Centros/535.png';
import COSSMILCBA from '../../../../app/public/assets/Centros/509.webp';
import CETRO from '../../../../app/public/assets/Centros/536.webp';
import SCLA from '../../../../app/public/assets/Centros/537.webp';
import PERINAT from '../../../../app/public/assets/Centros/539.webp';
import HA from '../../../../app/public/assets/Centros/540.webp';
import CSA from '../../../../app/public/assets/Centros/543.webp';
import HAP from '../../../../app/public/assets/Centros/542.webp';
import CPAD from '../../../../app/public/assets/Centros/545.webp';

import SDAR from '../../../../app/public/assets/Centros/501-small.png';
import SFUTURE from '../../../../app/public/assets/Centros/504-small.png';
import SmCLA from '../../../../app/public/assets/Centros/507-small.png';
import SSCANCENTER from '../../../../app/public/assets/Centros/511-small.png';
import SHNORTE from '../../../../app/public/assets/Centros/512-small.png';
import SDIAGNOS from '../../../../app/public/assets/Centros/517-small.png';
import SLONDRES from '../../../../app/public/assets/Centros/518-small.png';
import SSSUCBBA from '../../../../app/public/assets/Centros/519-small.png';
import SCEMES from '../../../../app/public/assets/Centros/525-small.png';
import SBELGA from '../../../../app/public/assets/Centros/526-small.png';
import SONCOSUR from '../../../../app/public/assets/Centros/528-small.png';
import SMEDCENT from '../../../../app/public/assets/Centros/532-small.png';
import SRESOMEDICA from '../../../../app/public/assets/Centros/534-small.png';
import SSPACIO_MEDICO from '../../../../app/public/assets/Centros/535-small.png';
import SCOSSMILCBA from '../../../../app/public/assets/Centros/509-small.webp';
import SCETRO from '../../../../app/public/assets/Centros/536-small.webp';
import SSCLA from '../../../../app/public/assets/Centros/537-small.png';
import SPERINAT from '../../../../app/public/assets/Centros/539-small.webp';
import SHA from '../../../../app/public/assets/Centros/540-small.png';
import SCSA from '../../../../app/public/assets/Centros/543-small.webp';
import SHAP from '../../../../app/public/assets/Centros/542-small.webp';
import SCPAD from '../../../../app/public/assets/Centros/545-small.webp';

export const clientLogos: Record<string, string> = {
  501: DAR,
  504: FUTURE,
  507: CLA,
  509: COSSMILCBA,
  511: SCANCENTER,
  512: HNORTE,
  517: DIAGNOS,
  518: LONDRES,
  519: SSUCBBA,
  525: CEMES,
  526: BELGA,
  528: ONCOSUR,
  532: MEDCENT,
  534: RESOMEDICA,
  535: SPACIO_MEDICO,
  536: CETRO,
  537: SCLA,
  539: PERINAT,
  540: HA,
  543: CSA,
  542: HAP,
  545: CPAD,
};

export const clientLogosSmall: Record<string, string> = {
  501: SDAR,
  504: SFUTURE,
  507: SmCLA,
  509: SCOSSMILCBA,
  511: SSCANCENTER,
  512: SHNORTE,
  517: SDIAGNOS,
  518: SLONDRES,
  519: SSSUCBBA,
  525: SCEMES,
  526: SBELGA,
  528: SONCOSUR,
  532: SMEDCENT,
  534: SRESOMEDICA,
  535: SSPACIO_MEDICO,
  536: SCETRO,
  537: SSCLA,
  539: SPERINAT,
  540: SHA,
  543: SCSA,
  542: SHAP,
  545: SCPAD,
};
